/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_ThreadsInputs */



/**
* | output |
* | --- |
* | "Manage Threads and Posts" |
*
* @param {Leveling_Perm_Manage_ThreadsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_threads = /** @type {((inputs?: Leveling_Perm_Manage_ThreadsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_ThreadsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управлять ветками и публикациями")
	return /** @type {LocalizedString} */ ("Manage Threads and Posts")
});